import { render, staticRenderFns } from "./TradingSoftwareDevPage.vue?vue&type=template&id=15bc26fa&scoped=true"
import script from "./TradingSoftwareDevPage.vue?vue&type=script&lang=js"
export * from "./TradingSoftwareDevPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc26fa",
  null
  
)

export default component.exports